import {
  Children,
  cloneElement,
  type HTMLAttributes,
  type PropsWithChildren
} from 'react';
import { cn } from 'utils/cn';
import { isTabElement, TAB_VARIANT_CLASSES, useTabsContext } from './Tabs';

function TabList({
  children,
  className,
  ...props
}: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) {
  const { variant } = useTabsContext();
  const variantClasses = TAB_VARIANT_CLASSES[variant];
  let tabIndex = 0;

  const enhancedChildren = Children.map(children, (child) => {
    if (!isTabElement(child)) {
      return child;
    }

    const index = tabIndex;
    tabIndex += 1;
    return cloneElement(child, { index });
  });

  return (
    <div
      role='tablist'
      className={cn(variantClasses.tabList, className)}
      {...props}>
      {enhancedChildren}
    </div>
  );
}

export default TabList;
